import React from "react";

/**
 *
 * @param {{
 *  size: 'h1' | 'h2' | 'h3' | 'h4'
 *  paddingX: number
 * }} props
 */
const Header = ({ size = "h1", paddingX = 0, children, style, ...rest }) => {
  const Component = size;
  return (
    <Component
      style={{
        paddingLeft: paddingX,
        paddingRight: paddingX,
        width: "100%",
        ...style,
      }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Header;
